import { create } from 'zustand';

// Which surface a SUPER_ADMIN or COACH is currently viewing — the admin
// sidebar/tools, or the same "Practice" surface a candidate sees
// (Sessions/Packages). Only meaningful for those roles; USER always renders the
// candidate surface regardless of this value.
export type SurfaceMode = 'admin' | 'candidate';

interface SurfaceModeState {
  mode: SurfaceMode;
  setMode: (mode: SurfaceMode) => void;
}

export const useSurfaceModeStore = create<SurfaceModeState>((set) => ({
  mode: 'admin',
  setMode: (mode) => set({ mode }),
}));

export default useSurfaceModeStore;
